import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SEOHelmet from "./SEOHelmet";

function AboutMe() {
  return (
    <>
      <SEOHelmet
        title="About Rick Molenaar - IT Management Consultant & Engineering Leader"
        description="I started my career as well as my journey around the world by combining backpacking with freelance coding in Australia. Over 25 years of experience in software engineering leadership."
        canonicalUrl="https://rickmolenaar.me/aboutme"
      />
      <Container
        fluid
        className="bg-theme-primary text-theme-accent3 full-height "
      >
        <Row className="justify-content-center">
          <Col className="px-4">
            <div className="text-center mt-3 mb-3">
              <img
                src="./images/rick_1024.jpg"
                alt="Rick Molenaar"
                className="circular-image"
              />
            </div>
            <p>
              I started my career by combining backpacking with freelance coding
              in Australia. Software engineering was the skill that let me
              explore the world, connect with people, and build something along
              the way. Living and working across different countries taught me
              to read new contexts fast, understand how things are done
              elsewhere, and find practical ways forward.  These habits that have
              stayed with me ever since.
            </p>
            <p>
              Over time that grew into a passion for building effective tech
              organizations and the people leading them. I understand the
              technical depth engineers work in, which means my empathy is
              informed: I know when something is genuinely hard, when a decision
              needs more time, and when a better approach is worth pushing for.
              That technical grounding, combined with 25 years of experience
              across software engineering, CTO, CIO, and interim executive
              roles, is what lets me contribute at the level organizations
              actually need.
            </p>
            <p>
              My background doesn't fit neatly into one box. I've worked as an
              engineer, led as an executive, and taken on roles in change
              management and transition leadership. I don't claim to be the best
              in each discipline, but I've learned enough from all of them to
              bring a practical mix that helps organizations move forward. I
              stay hands-on when it matters, whether that means developing
              decision models, writing job profiles, or improving tools, while
              keeping the bigger picture in view. And being external gives me a
              fresh perspective without the overhead, slide decks, or upselling
              that often come with large firms.
            </p>
            <p>
              My clients range from scaleups to large corporates running into
              challenges with their software engineering organization. Sometimes
              that means stepping in as interim CTO, CIO, or VP of Engineering.
              Sometimes it's guiding a restructure, merger, or acquisition.
              Often it's simply that the tech organization is growing, changing,
              or not performing as expected, in delivery, in leadership, or
              both.
            </p>
            <p>
              If you're facing that kind of transition and need a senior partner
              to help you through it, I'd be glad to talk.
            </p>
          </Col>
        </Row>
        <Row className="text-center">
          <Col className="mb-5">
            <a
              href={"/connect"}
              className="btn btn-primary mt-auto font-weight-bold"
            >
              Lets connect
            </a>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AboutMe;
